import type { ReactNode } from "react";
import { Container, Stack, Text } from "@generalapplications/ui";

import { SectionHeader } from "./SectionHeader";
import { Reveal } from "@/app/common/components/composite/motion/Reveal";
import { formatText } from "@/app/common/functions/format/formatText";

export type PageSectionProps = {
  /** An in-page anchor, such as the home page's capabilities. */
  id?: string;
  eyebrow?: string;
  title: string;
  subheading?: string;
  /** Paragraphs under the heading, at reading size. */
  body?: readonly string[];
  children?: ReactNode;
};

/** One titled section of a page: its header, its paragraphs, its content. */
export function PageSection({
  id,
  eyebrow,
  title,
  subheading,
  body,
  children,
}: PageSectionProps) {
  return (
    <Stack as="section" id={id} gap="xl">
      <Reveal>
        <Stack gap="lg">
          <SectionHeader eyebrow={eyebrow} title={title} copy={subheading} />
          {body && (
            <Container width="lg" align="start">
              <Stack gap="md">
                {body.map((paragraph) => (
                  <Text key={paragraph} variant="prose">
                    {formatText(paragraph)}
                  </Text>
                ))}
              </Stack>
            </Container>
          )}
        </Stack>
      </Reveal>
      {children}
    </Stack>
  );
}
